import { render } from "./ManualDisplay.vue?vue&type=template&id=68d7cb9d"
import script from "./ManualDisplay.vue?vue&type=script&lang=ts"
export * from "./ManualDisplay.vue?vue&type=script&lang=ts"
script.render = render

export default script